export default "__VITE_PUBLIC_ASSET__da625631__"